"use client";

import Link, { type LinkProps } from "next/link";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type RomaReservationWidgetLinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> &
  Pick<LinkProps, "prefetch"> & {
    children: ReactNode;
    href?: string;
  };

function scrollToRomaReservationWidget(href: string): boolean {
  const targetUrl = new URL(href, window.location.href);
  const isCurrentPage =
    targetUrl.origin === window.location.origin &&
    targetUrl.pathname === window.location.pathname;
  const widget = document.getElementById("roma-reservation-widget");

  if (!isCurrentPage || !widget) {
    return false;
  }

  window.history.pushState(null, "", `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`);
  widget.scrollIntoView({ block: "start", behavior: "smooth" });
  return true;
}

export function RomaReservationWidgetLink({
  children,
  href = "#roma-reservation-widget",
  onClick,
  ...props
}: RomaReservationWidgetLinkProps) {
  return (
    <Link
      href={href}
      onClick={(event) => {
        if (scrollToRomaReservationWidget(href)) {
          event.preventDefault();
        }
        onClick?.(event);
      }}
      {...props}
    >
      {children}
    </Link>
  );
}
